var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleMediaDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 13.1667C5.37467 13.1667 4.98245 13.0037 4.65634 12.6776C4.32967 12.3509 4.16634 11.9584 4.16634 11.5001V2.33341C4.16634 1.87508 4.32967 1.48258 4.65634 1.15591C4.98245 0.829803 5.37467 0.666748 5.83301 0.666748H9.99967L11.6663 2.33341H17.4997C17.958 2.33341 18.3505 2.49675 18.6772 2.82341C19.0033 3.14953 19.1663 3.54175 19.1663 4.00008V11.5001C19.1663 11.9584 19.0033 12.3509 18.6772 12.6776C18.3505 13.0037 17.958 13.1667 17.4997 13.1667H5.83301ZM16.6663 16.5001H2.49967C2.04134 16.5001 1.64912 16.337 1.32301 16.0109C0.996341 15.6842 0.833008 15.2917 0.833008 14.8334V4.00008H2.49967V14.8334H16.6663V16.5001ZM7.49967 9.83341H15.833L13.0205 6.08341L10.833 9.00008L9.47884 7.18758L7.49967 9.83341Z",
    fill: "#004ddd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleMediaDark);
export default __webpack_public_path__ + "static/media/multiple_media_dark.19ffc009116d2e0f2b5f65c958888ad5.svg";
export { ForwardRef as ReactComponent };